<template>
  <div class="publishing-mp-config">
    <ConfigList>
      <ul>
        <li>
          <SpreadshopLogo class="logo" />
          <ToggleSwitch
            :model-value="atLeastOneShopPublished"
            :disabled="toggleDisabled"
            @update:model-value="setPublishingForAllShops"
          />
        </li>
        <li>
          <p>{{ $t('PUBLISHING.DETAIL.POS.STATUS.LABEL') }}</p>
          <CompositionPosStatusBadge
            :pos-types="[posStatus.posType]"
            :status="posStatus.status"
            hide-icon
          />
        </li>
        <li v-if="shops.length > 1">
          <p>{{ $t('PUBLISHING.DETAIL.SHOP.SHOPS_SELECTED.LABEL') }}</p>
          <button class="shop-dialog-btn" @click="openShopDialog">
            {{ publishedShops.length }}/{{ shops.length }}
            <Icon icon="right" />
          </button>
        </li>
        <li v-if="rejected">
          <p>{{ $t('PUBLISHING.DETAIL.POS.REJECTION_REASON.LABEL') }}</p>
          <button
            class="link rejection-reason-link"
            @click="openRejectionReasonDialog"
          >
            {{ $t(rejectionReasonName) }} <Icon icon="right" />
          </button>
        </li>
      </ul>
    </ConfigList>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mapState as mapPiniaState, mapActions } from 'pinia';
import ToggleSwitch from 'commons/toggleSwitch/ToggleSwitch.vue';
import SpreadshopLogo from 'commons/logos/SpreadshopLogo.vue';
import ConfigList from 'src/app/components/publishing/ConfigList.vue';
import RejectionReasonDialog from 'src/app/components/publishing/RejectionReasonDialog.vue';
import dialogService from 'commons/dialogs/wrapper/dialogService';
import { rejectionReasonName } from 'commons/api/models/publishingCore/publishingCore';
import ShopSelectionDialog from 'src/app/components/publishing/ShopSelectionDialog.vue';
import {
  getCompositionPosStateForPosType,
  COMPOSITION_POS_TYPES,
  COMPOSITION_POS_STATES,
} from 'commons/api/models/publishingCore/compositionPosStates';
import CompositionPosStatusBadge from 'src/app/components/publishing/statusBadges/CompositionPosStatusBadge.vue';
import { useCompositionStore } from 'commons/stores/composition';

export default {
  name: 'PublishingShopConfig',
  components: {
    ToggleSwitch,
    SpreadshopLogo,
    ConfigList,
    CompositionPosStatusBadge,
  },
  props: {},
  data() {
    return {
      mpSelected: false,
    };
  },
  computed: {
    ...mapPiniaState(useCompositionStore, {
      composition: (store) => store.current,
      publishedShops: (store) =>
        store.current.publishingDetails.spreadShops.shops,
    }),
    ...mapState({
      shops: (s) => s.publishingCore.shops,
    }),
    ...mapGetters({
      registeredUserShops: 'publishingCore/registeredUserShops',
    }),
    atLeastOneShopPublished() {
      return !!this.publishedShops.length;
    },
    rejected() {
      return this.posStatus.status === COMPOSITION_POS_STATES.REJECTED;
    },
    rejectionReasonName() {
      return rejectionReasonName(
        this.composition.publishingDetails.spreadShops.accreditation
          .rejectionReasons?.[0],
      );
    },
    posStatus() {
      return getCompositionPosStateForPosType({
        composition: this.composition,
        posType: COMPOSITION_POS_TYPES.SHOP,
      });
    },
    toggleDisabled() {
      return this.rejected && !this.atLeastOneShopPublished;
    },
  },
  created() {},
  methods: {
    ...mapActions(useCompositionStore, [
      'publishToShop',
      'unpublishFromShop',
      'publishToAllShops',
      'unpublishFromAllShops',
      'setPublishedShops',
    ]),
    openRejectionReasonDialog() {
      dialogService.openDialog(RejectionReasonDialog, {
        reason:
          this.composition.publishingDetails.spreadShops.accreditation
            .rejectionReasons?.[0],
      });
    },
    setPublishingForAllShops(publishStatus) {
      if (publishStatus) {
        this.publishToAllShops();
      } else {
        this.unpublishFromAllShops();
      }
    },
    async openShopDialog() {
      await dialogService
        .openDialog(ShopSelectionDialog, {
          shops: this.registeredUserShops,
          selectedShopIds: this.publishedShops.map((shop) => shop.id),
          heading: 'PUBLISHING.DETAIL.SHOP.SELECTION_DIALOG.HEADING',
          subheading: 'PUBLISHING.DETAIL.SHOP.SELECTION_DIALOG.SUBHEADING',
        })
        .then(this.setPublishedShops);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.logo {
  height: 24px;
}

.rejection-reason-link {
  font-weight: normal;
  color: $grey80;
  .icon {
    margin-left: 8px;
  }
}

.shop-dialog-btn {
  .icon {
    margin-left: 8px;
  }
}
</style>
